import React, { useState } from "react";

import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import { Box, ListItemText, MenuList, Paper } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import MenuIcon from "@mui/icons-material/Menu";
import FaceIcon from "@mui/icons-material/Face";
import CheckIcon from "@mui/icons-material/Check";

const MenuPage = () => {
  const [selectedItem, setSelectedItem] = useState("");

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement>,
    index: number
  ) => {
    setSelectedItem("");
  };


  const [openmember, setopenmember] = React.useState(false);

  const ClickMember = () => {
    setopenmember(!openmember);
  };

  const [openwork, setopenwork] = React.useState(false);

  const ClickWork = () => {
    setopenwork(!openwork);
  };


  var nav = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const goMain = () => {
    // window.location.href = "/insight/member/list";
    nav("/insight/member/list");
  };

  const hanwool = () => {
    nav("/insight/member/hanwool");
  };

  const wools = () => {
    nav("/insight/member/wools");
  };

  const upload_test = () => {
    nav("/insight/member/upload")
  }
  
  const tree = () => {
    nav("/insight/member/tree")
  }

  return (
    <Paper
      sx={{ width: "254px", height: "calc(100vh - 54px)", overflow: "auto" }}
    >
      <Box sx={{ marginTop: 8, borderTop: "1px solid #eee" }}>
        <MenuList>


          <MenuItem onClick={ClickWork}>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText>사용자 관리</ListItemText>
            {open ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={openwork} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                selected={selectedItem === "사용자 관리"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("사용자 관리");  setopenmember(false); }}
              >
                <ListItemText
                  primary="사용자 관리"
                  onClick={() => nav("/insight/member/management")}
                />
                <ListItemIcon>
                  {selectedItem === "사용자 관리" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              <ListItemButton
                selected={selectedItem === "CMS 관리용"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("CMS 관리용");  setopenmember(false); }}
              >
                <ListItemText
                  primary="CMS 관리용"
                  onClick={() => nav("/insight/member/cms")}
                />
                <ListItemIcon>
                  {selectedItem === "CMS 관리용" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
                
              </ListItemButton>
              <ListItemButton
                selected={selectedItem === "근태관리"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("근태관리");  setopenmember(false); }}
              >
                <ListItemText
                  primary="근태관리"
                  onClick={() => nav("/insight/member/attendance")}
                />
                <ListItemIcon>
                  {selectedItem === "근태관리" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
                
              </ListItemButton>
            </List>
          </Collapse>



          <MenuItem onClick={ClickMember}>
            <ListItemIcon>
              <MenuIcon />
            </ListItemIcon>
            <ListItemText>작업 리스트</ListItemText>
            {open ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={openmember} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                selected={selectedItem === "단어 리스트"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("단어 리스트");  setopenwork(false); }}
              >
                <ListItemText
                  primary="단어 리스트"
                  onClick={() => nav("/insight/asv/prcWrd")}
                />
                <ListItemIcon>
                  {selectedItem === "단어 리스트" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              <ListItemButton
                selected={selectedItem === "파일 업로드"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("파일 업로드");  setopenwork(false); }}
              >
                <ListItemText primary="파일 업로드" onClick={upload_test} />
                <ListItemIcon>
                  {selectedItem === "파일 업로드" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              <ListItemButton
                selected={selectedItem === "파일 저장소"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("파일 저장소");  setopenwork(false); }}
              >
                <ListItemText primary="파일 저장소" onClick={tree} />
                <ListItemIcon>
                  {selectedItem === "파일 저장소" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
            </List>
          </Collapse>

          {/* <MenuItem onClick={asClick}>
            <ListItemIcon>
              <FaceIcon />
            </ListItemIcon>
            <ListItemText primary="한울" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={asopen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                selected={selectedItem === "사용자 목록"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("사용자 목록"); setopenmember(false); setopenwork(false); }}
              >
                <ListItemText primary="사용자 목록" onClick={goMain} />
                <ListItemIcon>
                  {selectedItem === "사용자 목록" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              <ListItemButton
                selected={selectedItem === "한울 테스트"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("한울 테스트"); setopenmember(false); setopenwork(false); }}
              >
                <ListItemText primary="한울 테스트" onClick={hanwool} />
                <ListItemIcon>
                  {selectedItem === "한울 테스트" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              <ListItemButton
                selected={selectedItem === "울이 목록"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("울이 목록"); setopenmember(false); setopenwork(false); }}
              >
                <ListItemText primary="울이 목록" onClick={wools} />
                <ListItemIcon>
                  {selectedItem === "울이 목록" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              
            </List>
          </Collapse> */}
        </MenuList>
      </Box>
    </Paper>
  );
};

export default MenuPage;
